module.exports = __webpack_public_path__ + "img/app_d.ca0e3f4c.png";